export default "__VITE_ASSET__BiDzhx6q__"